<div class="message">
    <h1>Access Denied</h1>
    <div *ngIf='message'>{{message}}</div>
    <div class="buttons">
        <a class="bp hero" [routerLink]='["/"]'><i class="fa fa-home" aria-hidden="true"></i> Go to Home Page</a>
    </div>
</div>
